import { useState } from "react";
import { FilterButton, FilterCounter } from "../../UserManagement/UsersTable/styled";
import { FlexContainers, SearchInput, SVG, WrapperContainer } from "../../../components";
import PropTypes from "prop-types";

const FilterTabContainer = ({
  searchValue,
  setSearchValue,
  searchPlaceholder,
  FilterComponent,
  ControlsComponent
}) => {
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [activeFilters, setActiveFilters] = useState(0);

  return (
    <>
      <WrapperContainer Container={FlexContainers.FlexRowBetween} gap={24} mb={12} mt={12}>
        <WrapperContainer Container={FlexContainers.FlexRow} gap={8} width={"100%"} maxWidth={393}>
          <SearchInput
            id="filter-search"
            value={searchValue}
            setValue={setSearchValue}
            placeholder={searchPlaceholder}
          />
          <FilterButton active={filtersVisible} onClick={() => setFiltersVisible((prev) => !prev)}>
            <SVG.TuneIcon />
            {activeFilters > 0 && <FilterCounter>{activeFilters}</FilterCounter>}
          </FilterButton>
        </WrapperContainer>

        {ControlsComponent}
      </WrapperContainer>
      <FilterComponent visible={filtersVisible} setActiveFilters={setActiveFilters} />
    </>
  );
};

FilterTabContainer.propTypes = {
  searchValue: PropTypes.string,
  setSearchValue: PropTypes.string.isRequired,
  searchPlaceholder: PropTypes.string.isRequired,
  FilterComponent: PropTypes.object.isRequired,
  ControlsComponent: PropTypes.node
};

export default FilterTabContainer;
